import {
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/next-schema";
import { Node_Type } from "./../ricos-types";
const PAGE_SIZE = 25;
const WAIT_INTERVAL = 350;
const DEFAULT_CONFIGS = Object.freeze({
  editor: {
    size: "content",
    alignment: "center"
  },
  viewer: {
    sizes: { desktop: "original", mobile: "original" }
    // original or downsizedSmall are supported
  }
});
const RICOS_DEFAULTS = {
  containerData: {
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  }
};
const gifModals = {
  insert: `${Node_Type.GIF}.insert`,
  replace: `${Node_Type.GIF}.replace`
};
const GIF_BUTTONS = {
  alignment: `${Node_Type.GIF}.alignment`,
  size: `${Node_Type.GIF}.size`
};
const imagePlaceholder = (
  // eslint-disable-next-line max-len
  "data:image/webp;base64, UklGRtgAAABXRUJQVlA4IMwAAABQFgCdASomASYBPhkMhUIhBAUABABhLS3cLuwjaAE9gHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99qwAAP7/9viAAAAAAAAAAAAAAAA="
);
export {
  DEFAULT_CONFIGS,
  GIF_BUTTONS,
  PAGE_SIZE,
  RICOS_DEFAULTS,
  WAIT_INTERVAL,
  gifModals,
  imagePlaceholder
};
//# sourceMappingURL=constants.js.map
